import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareTimelineClassicRoute: InvariantJiraRoute = {
	name: 'software-timeline-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline/:viewId?',
};
